import React from "react";
import "./CancerName.css";
import { Link } from 'react-router-dom';

// 1. 컴포넌트 외부에 유틸리티 함수 선언 (리렌더링 시 불필요한 재생성 방지)
const restoreHashmark = (str) => {
    if (!str) return str;
    // 2. 정규식을 사용하여 문자열 내의 '모든' hashmark를 #으로 변경합니다.
    return str.replace(/hashmark/g, '#');
};

// 3. props 대신 { data } 구조 분해 할당 사용
function CancerName({ data }) {
    // 4. 안전하게 Key 또는 Organoid_Info_Key를 가져옵니다.
    const value = data.Key || data.Organoid_Info_Key;

    return (
        <div className="cancerName">
            <div className="customLink">
                {/* 5. 템플릿 리터럴(` `)을 사용하여 문자열을 더 깔끔하게 연결합니다. */}
                <Link to={`/organoid/${value}`} className="customLink">
                    {/* 6. 복잡했던 || 연산을 제거하고 위에서 구한 value를 바로 변환합니다. */}
                    {restoreHashmark(value)}
                </Link>
            </div>
        </div>
    );
}

export default CancerName;